export default "__VITE_ASSET__D84T1VQZ__"